// extracted by mini-css-extract-plugin
export default {"lostGrid":"lostGrid___3VscD","full":"full___nhqt1","wide":"wide___3eHP0","regular":"regular___bHTQf"};